import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, debounceTime, map, mergeMap, tap } from 'rxjs/operators';
import * as fromActions from './customer-scheduling.actions';
import { CustomerSchedulingService } from '../../modules/report-components/services/customer-scheduling.service';
import * as fromEvents from "../../modules/audits/tracking/events";
import { TrackingService } from "../../modules/shared/services/tracking.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class CustomerSchedulingEffects {
  constructor(private actions$: Actions, private settings: CustomerSchedulingService, private tracking: TrackingService, private snackBar: MatSnackBar) {}

  loadPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadAreaPreference),
      mergeMap(action =>
        (action.reportToken ? this.settings.getSettingsByToken(action.reportToken) : this.settings.getSettings()).pipe(
          map(res => fromActions.loadAreaPreferenceSuccess({ areaPreference: res })),
          catchError(error => of(fromActions.loadAreaPreferenceError({ error }))),
        ),
      ),
    ),
  );

  loadScheduledDates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadScheduledDates),
      mergeMap(action =>
        (action.reportToken
          ? this.settings.getScheduledDatesByToken(action.reportToken)
          : this.settings.getScheduledDates()
        ).pipe(
          map(res => fromActions.loadScheduledDatesSuccess({ scheduledDates: res })),
          catchError(error => of(fromActions.loadScheduledDatesError({ error }))),
        ),
      ),
    ),
  );

  requestAudit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.requestAudit),
      mergeMap(action =>
        (action.reportToken
          ? this.settings.requestAuditByToken(action.reportToken, action.extraAudit)
          : this.settings.requestAudit(action.extraAudit)
        ).pipe(
          map(res => fromActions.requestAuditSuccess()),
          tap(_ => {
            this.snackBar.open('Audit successfully requested', 'Ok', { duration: 3000 });
            this.tracking.track(fromEvents.requestExtraAudit());
          }),
          catchError(error => of(fromActions.requestAuditError({ error }))),
        ),
      ),
    ),
  );

  clearAcceptedStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.requestAuditSuccess),
      debounceTime(7000),
      map(action => fromActions.clearAcceptedStatus()),
    ),
  );
}
